<template>
	<div id="vip" v-if="loaded">
		<div class='account'>
			<div class='account-info'>
				<img v-bind:src="userInfo.avatar"/>
				<div class='member-name'>
					<div class='h3'>{{userInfo.nickname}}</div>
					<div class='h4'>{{userInfo.user_level_endstr}}</div>
				</div>
			</div>
		</div>
		<div class='package'>
			<div class='h3'>
			  请选择
			</div>
			<div class='package-list'>
				<div class="package-li" v-bind:class="{active:userlevel.id == item.id}" v-for="item in userlevels" v-on:click="event_check(item)">
					<div class='h4'>{{item.subject}}</div>
					<div class='price'>￥{{item.price}}</div>
					<div class='original-price'>原价￥{{item.sprice}}</div>
				</div>
			</div>
			<div class='h3'>
			  购买说明
			</div>
			<div class='intro'>
			  <div v-html="this.$store.state.config.data.vip_explain"/>
			</div>
			<div class='joinbutton'>
				<button v-on:click="event_submit">立即购买</button>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'Vip',
	data () {
		return {
			loaded:false,
			userInfo:{},
			userlevels:[],
			userlevel:{},//当前选中的会员级别
			back:0
		}
	},
	created (){
		var that = this;
		  this.$app.pr('/api/userlevel/lists',{}).then((res) => {

			that.setData({
			  userlevels: res.data,
			  userlevel:res.data[0]
			});
				that.loaded = true
		  });
		  that.setData({
			userInfo: this.$store.state.userInfo
		  });
	},
	computed: {
	},
	methods:{
		setData(params){
			for(var n in params){
				this[n] = params[n]
			}
		},
		event_check(item){
			this.setData({
				userlevel:item
			})
		},
		event_submit(){
			var that = this;
			var app = this.$app;
			var wx = this.$wx;
			app.globalData = {
				config:this.$store.state.config.data
			}
			if (app.globalData.platform != 'android' && app.globalData.config.iphonepay != '1'){
			  wx.showModal({
				title: '警告',
				content: '尊敬的学员你好 ，因内网更新，导致部分苹果手机不能支付，请联系客服087164180721                         13888142034'
			  })
			  return false;
			}
			app.pr('/api/pay/vip',{
			  vip_id:this.userlevel.id
			}).then((params) => {
				that.$wx.requestPayment(params.data.paymentParams).then((res) => {
					wx.navigateTo({
						url: '/payresult?order_sn=' + params.data.order_sn,
					});
				}).catch((res) => {
					wx.showToast({
						title: '支付失败',
					});
				})
			}).catch((res) => {
				wx.showToast({
					title: '支付失败，请重试',
				});
			});
		}
	}
}
</script>
<style scoped>
#vip{
	background-color:#fff;
	min-height:100vh;
}
.account{
  background:url(http://jk.ioccn.com/jiakao/kt-huiyuanbg.jpg) no-repeat;
  width: 100%;
  background-size: cover;
  height: 122px;
  color: #fff;
  align-items: center;
  display: flex;
}
.account-info{
  padding: 10px 0 10px 10px;
  display: flex;
  align-items: center;
}
.account-info img{
  width: 70px;
  margin-right: 10px;
  height: 70px;
  border-radius: 100%;
}
.account-info .h4{
  font-size: 12px;
  margin-top: 5px;
}
.account .open{
  position: absolute;
  right: 0;
  text-align: center;
  width: 100px;
  height:45px;
  line-height:40px;
  overflow:hidden;
  top:40px;
  border-radius:50px;
  border-bottom-right-radius: 0;
  border-top-right-radius: 0;
  background: #999;
}
.account .open.active{
  background-color:#f8e0a0;
  font-weight:bold;
}
.account .open.active text{
  color:#7b5e26;
}
.account .open text{
  color: #fff;
  font-size: 14px;
}
.package{
  padding: 10px 0 10px 10px;
}
.package .h3{
  font-size: 16px;
  margin-top: 10px;
}
.package-list{
  margin-top: 10px;
  display: flex;
}
.package-li{
  margin-right: 10px;
  flex: 1;
  border: 1px solid #dedede;
  border-radius: 10px;
  padding: 10px 5px;
  text-align: center;
  margin-bottom:10px;
}
.package-li .h4{
  font-size: 14px;
}
.package-li .price{
  font-size: 16px;
  margin-top:20px;
  color: #7b5e26;
  font-weight: bold;
}
.package-li .original-price{
  color: #999;
  margin-top: 10px;
  font-size: 14px;
  text-decoration: line-through;
}
.package-li:active,.package-li.active{
  background: #f8e0a0;
  border: 1px solid #7b5e26;
}
.intro{
  margin-right:10px;
  margin-top: 15px;
  font-size: 14px;
  line-height: 30px;
}
.intro text{
  display:block;
  height:1px;
  width:100%;
}
.joinbutton{
  padding-right: 10px;
  margin-top: 30px;
}
.joinbutton button{
  background: linear-gradient(to right, #ffeca5, #c2a45b);
  font-size: 16px;
  width:100%;
  border:0px;
}
</style>



// WEBPACK FOOTER //
// src/components/Vip.vue